goog.provide('el8.ptdata.visitNotes');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.note.visit');
goog.require('el8.service.urls');

/**
 * Visit notes, including visit notes imported from other practices
 * but not including partial amendments (which are in ptdata.tempVisitNotes)
 */
el8.ptdata.visitNotes = (function() {

    var that = new el8_EntitySet({
        model: el8.ptdata.model.note.visit,
        // sort by signDate if available in both, otherwise fallback to id. (Descending sort)
        sortFn: function(a, b){
            if (a.getSignDate() || b.getSignDate()) { return b.getSignDate() - a.getSignDate(); }
            else { return b.getId() - a.getId(); }
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            var hadVitals = item.hasVitals();

            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('deleteVisitNote', [item.getId()]),
                success: function() {
                    if (hadVitals) {
                        $(document).trigger("el8_noteVitalUpdate");
                    }
                    if (successCb) {
                        successCb.apply(null, arguments);
                    }
                },
                error: errorCb,
                error_msg: opts.error_msg
            });
        }
    });

    // We will not include visits from other practices by default
    var super_all = that.all;
    that.all = function(includeImportedNotes) {
        if (includeImportedNotes) {
            return super_all.call(that);
        } else {
            return _.reject(super_all.call(that), function(vn) {
                return vn.isImportedNote();
            });
        }
    };
    var super_sorted = that.sorted;
    that.sorted = function(includeImportedNotes) {
        if (includeImportedNotes) {
            return super_sorted.call(that);
        } else {
            return _.reject(super_sorted.call(that), function(vn) {
                return vn.isImportedNote();
            });
        }
    };

    that.forceDeleteItem = function(item, noNotify, opts) {
        opts = opts || {};
        var hadVitals = item.hasVitals();
        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('deleteVisitNote', [item.getId()])+'?force=1',
            success: function() { 
                that.remove(item, noNotify); 
                if (hadVitals) { $(document).trigger("el8_noteVitalUpdate"); }
                if (opts.successCb) { opts.successCb(item); }
            },
            error: opts.errorCb,
            error_msg: opts.error_msg
        });
    };
    that.deleteItemSendBackImages = function(item, noNotify, opts, isForce) {
        opts = opts || {};
        var addlString = '?refile_images=1' + (isForce ? '&force=1' : '');
        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('deleteVisitNote', [item.getId()])+addlString,
            success: function() { 
                that.remove(item, noNotify); 
                if (opts.successCb) { opts.successCb(item); }
            },
            error: opts.errorCb,
            error_msg: opts.error_msg
        });
    };
    that.forceDeleteItemSendBackImages = function(item, noNotify, opts) {
        return that.deleteItemSendBackImages(item, noNotify, opts, true);
    };
    that.getLatestId = function() {
        var sorted = that.sorted();
        return sorted.length ? sorted[0].getId() : null;
    };
    // returns set of all the unsigned notes in order
    that.getUnsigned = function() {
        return that.sorted().filter(function(n){ return !n.getSignDate(); });
    };
    that.getSigned = function() {
        return that.sorted().filter(function(n){ return !!n.getSignDate(); });
    };

    that.getImportedNotes = function() {
        return super_sorted.call(that).filter(function(n) { return n.isImportedNote(); });
    };

    // Does NOT attach the bill object to the note at noteId, because
    // the user might decide not to save this bill. We just use that
    // ID to prepopulate the copay data in the bill
    that.createBill = function(noteId) {
        var bill = el8.ptdata.model.note.bill({});

        bill.setShowDualCoding(el8.data.currUser.isShowDualCodingEnabled());

        el8.data.serviceLocations.softLoad();
        var serviceLocations;
        if (el8.data.currPractice.isKareoIntegrated()) {
            // A bill without a mapped service location cannot be submitted to Kareo.
            // The bill dialog wouldn't let them save without a mapped location, but
            // if this code is running, the user may never open the bill dialog. So we'll
            // default a mapped service location if possible.
            serviceLocations = el8.data.serviceLocations.getKareoMappedLocations();
            if (serviceLocations.length) {
                bill.setServiceLocationId(serviceLocations[0].getId());
            }
        } else {
            // otherwise, only set a service location if there's exactly one
            serviceLocations = el8.data.serviceLocations.all();
            if (serviceLocations.length === 1) {
                bill.setServiceLocationId(serviceLocations[0].getId());
            }
        }
        if (el8Globals.FEATURES.FrontOfficeNewKareo) {
            // synchronous call that will populate the copay model and billing note
            // of this bill, using appointment from today if possible, but will use
            // an appoint from the same patient from up to 7 days ago if needed.
            bill.fetchInfoForBill(noteId);
        } else {
            // synchronous call that will populate the copay model
            // of this bill, if there any appointments from today
            bill.fetchCopayFromAppointments(noteId);
        }
        
        if (el8Globals.FEATURES.ServLocFromLastBill) {
            bill.fetchServiceLocationFromLastBill(noteId);
        }

        return bill;
    };

    return that;

})();
